import { EInvoicingSetupPath, EInvoicingSetupStep } from '../types'

export const E_INVOICING_STEP_TO_PATH: Record<EInvoicingSetupStep, EInvoicingSetupPath> = {
  EMPTY_STATE: 'empty-state',
  COMPANY_INFO: 'company-information',
  UPLOAD_DOCS: 'upload-documents',
  UPLOAD_ID_FRONT: 'upload-id-front',
  UPLOAD_ID_BACK: 'upload-id-back',
  UPLOAD_PASSPORT: 'upload-passport',
  FILES_SUCCESS: 'upload-success',
  SIGNATURE: 'signature',
}

export const E_INVOICING_PATH_TO_STEP: Record<string, EInvoicingSetupStep> = Object.fromEntries(
  Object.entries(E_INVOICING_STEP_TO_PATH).map(([step, path]) => [path, step as EInvoicingSetupStep]),
)
